export const PawPrint = ({ className = "w-8 h-8", color = "#3B82F6" }) => (
  <svg viewBox="0 0 64 64" fill={color} className={className} aria-hidden="true">
    <ellipse cx="32" cy="43" rx="14" ry="11" />
    <ellipse cx="13" cy="29" rx="6" ry="8.5" transform="rotate(-20 13 29)" />
    <ellipse cx="25" cy="18" rx="6" ry="8.5" transform="rotate(-8 25 18)" />
    <ellipse cx="40" cy="18" rx="6" ry="8.5" transform="rotate(8 40 18)" />
    <ellipse cx="52" cy="29" rx="6" ry="8.5" transform="rotate(20 52 29)" />
  </svg>
);

export const Heart = ({ className = "w-6 h-6", color = "#E63946" }) => (
  <svg viewBox="0 0 32 32" fill={color} className={className} aria-hidden="true">
    <path d="M16 28C8.5 21.5 3 16.2 3 10.8 3 6.9 6.2 4 10 4c2.4 0 4.6 1.2 6 3.2C17.4 5.2 19.6 4 22 4c3.8 0 7 2.9 7 6.8 0 5.4-5.5 10.7-13 17.2z" />
  </svg>
);

export const Bone = ({ className = "w-10 h-10", color = "#16294B" }) => (
  <svg viewBox="0 0 64 64" fill={color} className={className} aria-hidden="true">
    <path d="M14.5 22a7.5 7.5 0 1 1 10-10l1.6 1.6a4 4 0 0 0 5.6 0l9-9A7.5 7.5 0 1 1 51.3 15 7.5 7.5 0 1 1 56 25.4l-1.6-1.6a4 4 0 0 0-5.6 0l-22 22a4 4 0 0 0 0 5.6l1.6 1.6A7.5 7.5 0 1 1 18 58.2a7.5 7.5 0 1 1 4.6-14.2 4 4 0 0 0 5.6 0l9-9-9 9a4 4 0 0 0 0-5.6l-9-9a4 4 0 0 0-5.6 0z" transform="rotate(45 32 32) scale(0.9) translate(4 4)" opacity="0" />
    <path d="M49.5 14.5a7 7 0 1 0-9.9 0l-1.2 1.2a5 5 0 0 1-7 0l-1.2-1.2a7 7 0 1 0-9.9 9.9l1.2 1.2a5 5 0 0 1 0 7L9.7 45.4A7 7 0 1 0 14.5 49.5a7 7 0 1 0 9.9 9.9l12.8-12.8a5 5 0 0 1 7 0l1.2 1.2a7 7 0 1 0 9.9-9.9l-1.2-1.2a5 5 0 0 1 0-7l12.7-12.7a7 7 0 0 0 2.1-5z" opacity="0" />
    <g transform="rotate(-45 32 32)">
      <rect x="18" y="27" width="28" height="10" rx="5" />
      <circle cx="15" cy="25" r="8" />
      <circle cx="15" cy="39" r="8" />
      <circle cx="49" cy="25" r="8" />
      <circle cx="49" cy="39" r="8" />
    </g>
  </svg>
);

export const Squiggle = ({ className = "w-10 h-6", color = "#3B82F6" }) => (
  <svg viewBox="0 0 48 24" fill="none" stroke={color} strokeWidth="4" strokeLinecap="round" className={className} aria-hidden="true">
    <path d="M4 12 L14 4 M10 18 L24 6 M20 22 L34 10" />
  </svg>
);

export const ScribbleLine = ({ className = "w-32 h-3", color = "#E63946" }) => (
  <svg viewBox="0 0 120 12" fill="none" stroke={color} strokeWidth="4" strokeLinecap="round" className={className} aria-hidden="true">
    <path d="M3 8 C 20 2, 40 10, 60 6 S 100 4, 117 7" />
  </svg>
);
